module.exports = __webpack_public_path__ + "d1cb39775770d4972b63ecd2a137e4f3.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot
 ** module id = 636
 ** module chunks = 0
 **/